import { ReactNode } from "react";
import { mergeClassNames } from "../../../../../../utils/commonFunctions";

interface FormFieldsViewProps {
    formContent: ReactNode;
    scrollClassName?: string
    mode?: string
}

const FormFieldsView = ({formContent, scrollClassName, mode }: FormFieldsViewProps) => (
    <div className={mergeClassNames("form-grid modal__scrollbar__white", scrollClassName)}>
        {formContent}
    </div>
);

export default FormFieldsView;
